import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_2 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_3 = { class: "forms" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "field-content" }
const _hoisted_7 = {
  key: 0,
  class: "field-line"
}
const _hoisted_8 = { class: "field-value" }
const _hoisted_9 = { class: "field-value" }
const _hoisted_10 = { class: "field-value uppercase" }
const _hoisted_11 = { class: "field-value" }
const _hoisted_12 = {
  key: 0,
  style: {"color":"darkred"}
}
const _hoisted_13 = { class: "field-value" }
const _hoisted_14 = {
  key: 0,
  style: {"color":"darkred"}
}
const _hoisted_15 = { class: "field-value" }
const _hoisted_16 = {
  key: 1,
  class: "field-empty"
}
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { class: "field-content" }
const _hoisted_19 = {
  key: 0,
  class: "field-line"
}
const _hoisted_20 = { class: "field-value" }
const _hoisted_21 = { class: "field-value" }
const _hoisted_22 = { class: "field-value" }
const _hoisted_23 = {
  key: 1,
  class: "field-empty"
}

import { computed, onMounted, ref } from "vue";
import { debounce } from "lodash-es";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";
import {
  getDate,
  getHour,
  getDifference,
  getDiffBreaks,
} from "@/common/utils/dates";

import { sampleGet, samplePatch } from "@/common/api/rest/sample";
import {
  evaluationGet,
  evaluationSampleList,
} from "@/common/api/rest/evaluation";
import { analysisGet } from "@/common/api/rest/analysis";
import { resultList } from "@/common/api/rest/result";
import {
  fileAvatarCreate,
  fileAvatarUpdate,
  fileAvatarDelete,
} from "@/common/api/rest/file/avatar";

import type { SampleType } from "@/common/types/sample";
import type { EvaluationType } from "@/common/types/evaluation";
import type { AnalysisType } from "@/common/types/analysis";
import type { ResultType } from "@/common/types/result";

import { RegisterTheme } from "@/common/themes";
import { sampleForm } from "@/components";
import {
  baseConfirm,
  baseAvatar,
  iconMenu,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: '[sample]',
  setup(__props) {

const { t, tm } = useI18n();
const router = useRouter();
const route = useRoute();

const sample = ref<SampleType | null>(null);
const evaluation = ref<EvaluationType | null>(null);
const evaluationSample = ref<SampleType[] | null>(null);
const analyse = ref<AnalysisType | null>(null);
const results = ref<ResultType[] | null>(null);
const result = ref<ResultType | null>(null);

const selectedMenu = ref<string>("home");

const showDelAvatar = ref(false);

const accountId = computed(() => String(route.params.id));
const sampleId = computed(() => String(route.params.sample));

const analyseStartDate = computed(() => {
  if (!analyse.value) {
    return null;
  }

  return analyse.value.start_edited ?? analyse.value.start_date;
});

const analyseEndDate = computed(() => {
  if (!analyse.value) {
    return null;
  }

  return analyse.value.end_edited ?? analyse.value.end_date;
});

const analysisStatusEnum = computed(
  () => tm("enums.analysis_status") as Record<string, string>,
);

const menuTabs = computed(() => [
  {
    key: "home",
    icon: "home-line",
    label: t("common.labels.sample"),
  },
  {
    key: "memory",
    icon: "no-image",
    label: "Memória de Campo",
  },
  {
    key: "laboratory",
    icon: "laboratory",
    label: "Laboratório e Resultado",
  },
]);

function back() {
  router.push(`/${accountId.value}/register/sample`);
}

async function fetchSample() {
  if (!sampleId.value) {
    return;
  }

  await sampleGet(accountId.value, sampleId.value)
    .then((response) => {
      const { success, data } = response;

      if (success) {
        sample.value = data;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchEvaluation() {
  if (!sample.value?.evaluation_id) {
    return;
  }

  evaluationGet(sample.value.evaluation_id)
    .then((response) => {
      const { success, data } = response;

      if (success) {
        evaluation.value = data;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchEvaluationSample() {
  if (!sample.value?.evaluation_id) {
    return;
  }

  evaluationSampleList(sample.value.evaluation_id)
    .then((response) => {
      const { success, data } = response;

      if (success) {
        evaluationSample.value = data.list;
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchAnalysis() {
  if (!sample.value?.analysis_id) {
    return;
  }

  analysisGet(sample.value.analysis_id)
    .then((response) => {
      const { success, data } = response;

      if (success) {
        analyse.value = data;
        console.log("analyse", analyse.value);
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchResult() {
  if (!sample.value?.analysis_id) {
    return;
  }

  resultList(sample.value.analysis_id)
    .then((response) => {
      const { success, data } = response;

      if (success) {
        results.value = data.list;

        const resultFind = data.list?.find(
          (item: any) => item.sample_id === sample.value?.sample_id,
        );

        if (resultFind) {
          result.value = resultFind;
        }
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function intialize() {
  await fetchSample();
  fetchEvaluation();
  fetchEvaluationSample();
  fetchAnalysis();
  fetchResult();
}

function patchSample(payload: SampleType) {
  if (!sampleId.value) {
    return;
  }

  samplePatch(accountId.value, sampleId.value, payload)
    .then((response) => {
      const { success, data } = response;

      if (success) {
        fetchSample();
      } else {
        toast({ message: data.message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addAvatar(avatar: string) {
  fileAvatarCreate(accountId.value, {
    owner_id: sampleId.value,
    type: "SAMPLE",
    file: avatar,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchSample();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function updateAvatar(avatar: string) {
  if (!sample.value?.avatar) return;

  fileAvatarUpdate(accountId.value, sample.value.avatar.avatar_id, {
    file: avatar,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchSample();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeAvatar(avatar: string) {
  if (sample.value?.avatar) {
    updateAvatar(avatar);
  } else {
    addAvatar(avatar);
  }
}

function delAvatar() {
  showDelAvatar.value = true;
}

function delAvatarConfirm() {
  if (!sample.value?.avatar) return;

  fileAvatarDelete(accountId.value, sample.value.avatar.avatar_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchSample();
        showDelAvatar.value = false;
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeMenu(key: string) {
  selectedMenu.value = key;
  intialize();
}

function dateDiff(start_date: string | null, end_date: string | null) {
  if (!start_date) {
    return "0m 0s";
  }

  const diff = getDifference(
    start_date,
    end_date ? end_date : new Date().toISOString(),
  );

  return diff.text;
}

const debounceForm = debounce(patchSample, 1000);

onMounted(() => {
  intialize();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RegisterTheme), { "tab-active": "sample" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(svgIcon), {
            icon: "samples",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.edit", { concat: _unref(t)("common.labels.sample") })), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-back btn-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
        }, [
          _createVNode(_unref(svgIcon), {
            icon: "close",
            size: "1.25rem"
          })
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(iconMenu), {
        tabs: menuTabs.value,
        active: selectedMenu.value,
        onSelected: changeMenu
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (selectedMenu.value === 'home')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("common.labels.sample")), 1),
                  _createVNode(_unref(baseAvatar), {
                    url: sample.value?.avatar?.large,
                    "is-edit": true,
                    onChange: changeAvatar,
                    onDel: _cache[1] || (_cache[1] = ($event: any) => (delAvatar()))
                  }, null, 8, ["url"]),
                  _createVNode(_unref(sampleForm), {
                    width: "100%",
                    data: sample.value,
                    "is-patch": true,
                    "show-status": true,
                    "in-use": !!sample.value?.analysis_id,
                    onUpdateData: _unref(debounceForm)
                  }, null, 8, ["data", "in-use", "onUpdateData"])
                ], 64))
              : _createCommentVNode("", true),
            (selectedMenu.value === 'memory')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "title" }, "Memória de Campo", -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "field-title" }, "DADOS DA ANÁLISE", -1)),
                    _createElementVNode("div", _hoisted_6, [
                      (analyse.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "field-label" }, "Avaliação", -1)),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(evaluation.value?.code), 1),
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "field-label" }, "Análise", -1)),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(analyse.value?.code), 1),
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "field-label" }, "Status", -1)),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(analysisStatusEnum.value[analyse.value?.status]), 1),
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "field-label" }, " Início ", -1)),
                            _createElementVNode("span", _hoisted_11, [
                              _createTextVNode(_toDisplayString(_unref(getDate)(analyseStartDate.value)) + " - " + _toDisplayString(_unref(getHour)(analyseStartDate.value)) + " ", 1),
                              (analyse.value.start_edited)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (editado) "))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "field-label" }, "Fim", -1)),
                            _createElementVNode("span", _hoisted_13, [
                              _createTextVNode(_toDisplayString(_unref(getDate)(analyseEndDate.value)) + " - " + _toDisplayString(_unref(getHour)(analyseEndDate.value)) + " ", 1),
                              (analyse.value.end_edited)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, " (editado) "))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "field-label" }, "Tempo", -1)),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(dateDiff(analyseStartDate.value, analyseEndDate.value)), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, " Essa amostra ainda não foi associada a uma análise. "))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "field-title" }, "DADOS DO RESULTADO", -1)),
                    _createElementVNode("div", _hoisted_18, [
                      (result.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "field-label" }, "Nome", -1)),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(result.value.name), 1),
                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "field-label" }, "Resultado", -1)),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(result.value.result), 1),
                            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "field-label" }, "Observação", -1)),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(result.value.description), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, " Essa amostra ainda não possui resultado registrado. "))
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["tabs", "active"]),
      _createVNode(_unref(baseConfirm), {
        show: showDelAvatar.value,
        title: 
          _unref(t)('common.labels.remove', { concat: _unref(t)('common.labels.avatar') })
        ,
        message: 
          _unref(t)('common.texts.remove_message', {
            concat: _unref(t)('common.labels.avatar'),
          })
        ,
        onCancel: _cache[2] || (_cache[2] = ($event: any) => (showDelAvatar.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (delAvatarConfirm()))
      }, null, 8, ["show", "title", "message"])
    ]),
    _: 1
  }))
}
}

})